import {ExclamationTriangleIcon, XMarkIcon} from '@heroicons/react/20/solid';
import classNames from 'classnames';
import React from 'react';

interface IProps {
  className?: string;
  message: string;
  onDismiss?: () => void;
}

export const Info: React.FC<IProps> = (props) => {
  return (
    <div
      className={classNames(
        'rounded-md bg-blue-50 p-4 print:hidden',
        props.className,
      )}>
      <div className="flex">
        <div className="flex-shrink-0">
          <ExclamationTriangleIcon
            className="h-5 w-5 text-blue-400"
            aria-hidden="true"
          />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p className="text-sm text-blue-700">{props.message}</p>
        </div>
        {props.onDismiss && (
          <div className="ml-auto pl-3">
            <div className="-mx-1.5 -my-1.5">
              <button
                onClick={props.onDismiss}
                type="button"
                className="inline-flex rounded-md bg-blue-50 p-1.5 text-blue-500 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-blue-50">
                <span className="sr-only">Dismiss</span>
                <XMarkIcon aria-hidden="true" className="h-5 w-5" />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
